// @flow

import {
  type UserInputValidationError,
  type UserInputValidatorArgs,
  VALID,
} from '@tectonics/prs/validation';

export function validator({
  userInputName,
}: UserInputValidatorArgs): ?UserInputValidationError {
  switch (userInputName) {
    default:
      return VALID;
  }
}
